<div class="container">
  <table>
    <thead>
    <tr>
      <th *ngFor="let coluna of colunas">{{coluna}}</th>
    </tr>
    </thead>
    <tbody>
    <!-- Skeleton row 1 -->
    <tr>
      <td *ngFor="let coluna of colunas"><div class="skeleton-line medium"></div></td>
    </tr>
    <!-- Skeleton row 2 -->
    <tr>
      <td *ngFor="let coluna of colunas"><div class="skeleton-line medium"></div></td>
    </tr>
    <!-- Skeleton row 3 -->
    <tr>
      <td *ngFor="let coluna of colunas"><div class="skeleton-line medium"></div></td>
    </tr>
    <!-- Skeleton row 4 -->
    <tr>
      <td *ngFor="let coluna of colunas"><div class="skeleton-line medium"></div></td>
    </tr>
    <!-- Skeleton row 5 -->
    <tr>
      <td *ngFor="let coluna of colunas"><div class="skeleton-line medium"></div></td>
    </tr>
    </tbody>
  </table>
</div>
